import moment from 'moment';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AmountField, Card, Space, StatusField, TextField } from '~/components';
import GridLayout from '~/layout/GridLayout';
import { Transaction } from '~/types';

interface Props {
  record: Transaction;
  onClick?: () => void;
}

const TransactionCard: FC<Props> = (props) => {
  const { record, onClick } = props;
  const { t } = useTranslation('transactions');

  return (
    <Card
      title={
        <GridLayout xs={12}>
          <TextField label={t('posted')}>
            <AmountField amount={record.postedAmount} />
          </TextField>
          <TextField label={t('instructed')}>
            <AmountField amount={record.amount} />
          </TextField>
        </GridLayout>
      }
      status={record.status}
      onClick={onClick}
      expandable
    >
      <Space size={16} direction="vertical">
        <StatusField data={record.status} />
        {record.description && <TextField label={t('description')}>{record.description}</TextField>}
        <TextField label={t('date')}>{moment(record.createdAt).format('LL LT')}</TextField>
      </Space>
    </Card>
  );
};

export default TransactionCard;
